import cls from 'classnames';
import { forwardRef, MutableRefObject, useEffect, MouseEvent, FormEventHandler } from 'react';
import { Remark } from 'react-remark';
import remarkBreaks from 'remark-breaks';
import remarkEmoji from 'remark-emoji';

import useStyles from './styles';

type ResultTextInputAreaProps = {
  markdown: string;
  handleClick: (e: MouseEvent<HTMLDivElement>) => void;
  isEditable?: boolean;
  index: number;
  onInput: FormEventHandler<HTMLDivElement>;
  hasMaxHeight: boolean;
};

function moveCursorAtTheEnd(elem: HTMLDivElement) {
  const range = document.createRange();
  const selection = window.getSelection();

  selection.removeAllRanges();
  range.selectNodeContents(elem);
  range.collapse(false);
  selection.addRange(range);
}

function ResultTextInputArea(
  { markdown, handleClick, isEditable, onInput, hasMaxHeight }: ResultTextInputAreaProps,
  ref: MutableRefObject<HTMLDivElement>,
) {
  const classes = useStyles();

  useEffect(() => {
    if (!isEditable) {
      return;
    }
    moveCursorAtTheEnd(ref.current);
    ref.current.focus();
  }, [isEditable]);

  return (
    <div
      className={cls(classes.inputClassName, hasMaxHeight, classes.maxHeight)}
      onClick={handleClick}
      ref={ref}
      contentEditable={isEditable}
      onInput={onInput}
    >
      <Remark
        remarkPlugins={[remarkBreaks, remarkEmoji]}
        rehypeReactOptions={{
          components: {
            br: (props) => (
              <>
                <span className="br" {...props} />
                <br />
              </>
            ),
          },
        }}
      >
        {markdown}
      </Remark>
    </div>
  );
}

export default forwardRef(ResultTextInputArea);
